import React from 'react'
import { useNavigate } from 'react-router-dom';
import { FaInstagram,FaFacebookF,FaTwitter,FaYoutube } from "react-icons/fa";

const Footer = () => {
    
    const openLink=(link)=>{
        window.open(link);
    }
   
    return (
        <>
          <div className="footer">
              <div className="left" id='footer-left'>
                  <h2><a href="/contact">contact</a></h2>
              </div>
              <div className="middle" id='footer-middle'>
                  <h3>	&#xA9; Javidrandhir 2021</h3>
              </div>
              <div className="right" id='footer-right'>
                  <div className="links">
                      <i  onClick={()=>openLink('https://instagram.com/eclatecs2k22?utm_medium=copy_link')}><FaInstagram /></i>
                      <i onClick={()=>openLink('https://www.facebook.com/profile.php?id=100076449697821')}><FaFacebookF /></i>
                      <i onClick={()=>openLink('https://twitter.com/eclatecs2k22?t=bLpf4qVurtQBvdI3OWygdA&s=08')}><FaTwitter /></i>
                      <i><FaYoutube /></i>
                  </div>
              </div>
          </div>
        </>
    )
}

export default Footer
